// extracted by mini-css-extract-plugin
export var boxItems = "_82-1";
export var boxItemsLg = "_82-2";
export var button = "_82-7";
export var buttonLg = "_82-8";
export var filterGroupBox = "_82-0";
export var icon = "_82-3";
export var iconSecondary = "_82-6";
export var iconWrapper = "_82-4";
export var iconWrapperLg = "_82-5";